import { Record } from 'immutable';

const PropertySearchRequestRecord = Record({
  chain: null,
  brand: null,
  property: null,
  city: null,
  stateCode: null,
  countryCode: null,
  onlySubscribers: false
});

export class PropertySearchRequest extends PropertySearchRequestRecord {
  chain: string;
  brand: string;
  property: string;
  city: string;
  stateCode: string;
  countryCode: string;
  onlySubscribers: boolean;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/property-search-request.ts